import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import HomePageController from '../../apis/controller/homePage.controller';
import { images } from '../../assets/images';

import { routes } from '../../routes';

const TopBar = () => {
    // render() {
    const [homepage, setHomepage] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getHomepage();
    }, []);

    const [scrolles, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
    }, []);

    const getHomepage = async () => {
        setLoader(true);
        let res = await new HomePageController().homePage();
        if (res && res.status) {
            setHomepage(res.home_page);
        }
        setLoader(false);
    };



    return (
        <>
            <div className={scrolles ? "navshadow scrool" : "navshadow "}>
                <div className="topbar d-lg-block d-none">
                    <Container>
                        <Row className="align-items-center">
                            <Col xl={2} lg={2} md={3} sm={12} xs={12}>
                                <Link to={routes.index} className="logo_area">
                                    <img src={images.Logo} alt="..." className="img-fluid" />
                                </Link>
                            </Col>
                            {homepage && homepage.footer_section && homepage.footer_section.follow_us ? <Col xl={10} lg={10} md={9} sm={12} xs={12}>
                                <div className="topbar_right_area">
                                    <div className="d-flex align-items-center justify-content-end">
                                        <div className="topbar_item">
                                            <div className="social_icons">
                                                <ul className="list-inline">
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.facebook }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.facebook}>
                                                            <i className="fab fa-facebook-f"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.twitter }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.twitter}>
                                                            <i className="fab fa-twitter"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.linkedin }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.linkedin}>
                                                            <i className="fab fa-linkedin-in"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.youtube }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.youtube}>
                                                            <i className="fab fa-youtube"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.blogger }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.blogger}>
                                                            <i className="fab fa-blogger"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.google }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.google}>
                                                            <i className="fab fa-google-plus-g"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.telegram }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.telegram}>
                                                            <i className="fab fa-telegram-plane"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.skype }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.skype}>
                                                            <i className="fab fa-skype"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.wifi }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.wifi}>
                                                            <i className="fas fa-rss"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                    <li>
                                                        {/* <Link to={{ pathname: homepage.footer_section.follow_us.whatsapp }} target="_blank"> */}
                                                        <a href={homepage.footer_section.follow_us.whatsapp}>
                                                            <i className="fab fa-whatsapp"></i>
                                                        </a>
                                                        {/* </Link> */}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {homepage.footer_section.contact_info ? <div className="topbar_item">
                                            <div className="top_contact_info">
                                                <div className="icon_area">
                                                    <i className="fas fa-phone-alt"></i>
                                                </div>
                                                <div className="info_area">
                                                    <h6>Call Us On</h6>
                                                    <span><a href={`tel: ${homepage.footer_section.contact_info.phone_number_1}`}>{homepage.footer_section.contact_info.phone_number_1}</a></span>
                                                </div>
                                            </div>
                                        </div> : null}
                                        {homepage.footer_section.contact_info ? <div className="topbar_item">
                                            <div className="top_contact_info">
                                                <div className="icon_area">
                                                    <i className="fas fa-envelope-open"></i>
                                                </div>
                                                <div className="info_area">
                                                    <h6>Mail Us @</h6>
                                                    <span><a href={`mailto:${homepage.footer_section.contact_info.email}`}>{homepage.footer_section.contact_info.email}</a></span>
                                                </div>
                                            </div>
                                        </div> : null}
                                    </div>
                                </div>
                            </Col> : null}
                        </Row>
                    </Container>
                </div>
            </div>
            <div className='phone-view d-lg-none d-block'>
                <Container>
                    <Row className="align-items-center">
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className='phone_set'>
                                <div className='left_area_logo'>
                                    <Link to={routes.index} className="logo_area">
                                        <img src={images.Logo} alt="..." className="img-fluid" />
                                    </Link>
                                </div>
                                <div className='right_area_humber'>
                                    <Link to={routes.phonemenu}><i className="fal fa-bars"></i></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
    // }
}

export default TopBar;